import React, { Component } from 'react'

import "./Toolbar.css";


class ToolbarPlatformAccounts extends Component {


    render() {
        return (
            <div className="toolBar header_buttons">

            </div>
        )
    }
}

export default ToolbarPlatformAccounts

